const getSpaceIndexes = (label: string): number[] => {
  const indexes: number[] = [];
  let index = label.indexOf(' ');

  while (index !== -1) {
    indexes.push(index);
    index = label.indexOf(' ', index + 1);
  }

  return indexes;
};

// Splitting on the space nearest the middle keeps the two lines close in length
// without a max-width, so the badge stays as narrow as its longest line.
export const getBalancedLabelLines = (label: string): string[] => {
  const spaceIndexes = getSpaceIndexes(label);

  if (!spaceIndexes.length) {
    return [label];
  }

  const middle = label.length / 2;
  const splitAt = spaceIndexes.reduce((closest, index) =>
    Math.abs(index - middle) < Math.abs(closest - middle) ? index : closest,
  );

  return [label.slice(0, splitAt), label.slice(splitAt + 1)];
};
